<template>
  <div id="customTable" v-if="tableSet && viewRefreshKey">
    <el-table :id="tableId" :data="tableData" v-loading="isLoading && tableLoadingKey" :max-height="maxHeight"
      @selection-change="handleSelectionChange" ref="elTable">
      <el-table-column v-if="showSelection" type="selection" width="55" />
      <template v-for="(tableItem, index) of innerTableSet">
        <el-table-column :key="index" v-if="tableItem && (tableItem.isItemSettingsDisplay === undefined || tableItem.isItemSettingsDisplay) &&
          tableItem.titleBar && (!tableItem.titleBar.isDisplayFunc || tableItem.titleBar.isDisplayFunc())"
          :width="tableItem.itemWidth ? tableItem.itemWidth : 0"
          :min-width="tableItem.itemMinWidth ? tableItem.itemMinWidth : (tableItem.type === 'operations' ? 60 : 200)"
          :fixed="tableItem.type === 'operations' ? 'right' : false"
          :align="tableItem.type === 'operations' ? 'right' : tableItem.align || 'left'"
          :class-name="tableItem.type === 'operations' ? 'operations-column' : (tableItem.classNames || '')"
          :show-overflow-tooltip="tableItem.showTooltip"
          :type="tableItem.type === 'selection' && showRowSelection ? 'selection' : undefined">
          <template #header>
            <p v-if="tableItem.titleBar.type == 'text'" class="ct-text-p" :style="tableItem.itemStyle">
              {{ $t(tableItem.titleBar.title) }}
              <template v-if="tableItem.titleBar.filterKey">
                <template v-if="titleIconDisplay"></template>
                <span v-if="tableItem.titleBar.isFilterChecked" @click="onFilterIconClick(tableItem.titleBar)"
                  class="iconfont icon-shaixuan" style="font-size: 12px"></span>
              </template>
            </p>
            <p v-if="tableItem.titleBar.type == 'checkbox'" class="ct-text-p">
              <el-checkbox v-model="tableItem.titleBar.checkbox.checked"
                @change="handleCheckAllChange($event, tableItem)"></el-checkbox>
            </p>
            <p v-if="tableItem.titleBar.type == 'operations'" class="ct-text-p">
              <title-settings v-if="viewRefreshKey" ref="titleSettings" :table-set="innerTableSet"
                :router-name="routerName" @onSettingSaveClick="refreshTable"
                @onRestoreDefaultClick="refreshTable"></title-settings>
            </p>
            <div v-if="tableItem.titleBar.type == 'text_tooltip'">
              <div class="ct-text-p" style="display: flex; align-items: center;">
                <span style="margin-right: 5px;">{{ $t(tableItem.titleBar.title) }}</span>
                <el-tooltip effect="dark" :content="$t(tableItem.titleBar.tooltipContent)" placement="top"
                  popper-class="text-popper">
                  <i class="el-icon-warning-outline"></i>
                </el-tooltip>
              </div>
            </div>
          </template>

          <template #default="record">
            <div>
              <!-- 序号 -->
              <p v-if="tableItem.type == 'serialNumber'" class="ct-text-p"
                :style="record.row[tableItem.key].itemStyle ? record.row[tableItem.key].itemStyle(record.row[tableItem.key].itemData) : ''">
                {{ (paginationInfo.currentPage - 1) * paginationInfo.pageSize + record.$index + 1 }}
              </p>
              <!--普通显示-->
              <p v-if="tableItem.type == 'text'" class="ct-text-p"
                :style="record.row[tableItem.key].itemStyle ? record.row[tableItem.key].itemStyle(record.row[tableItem.key].itemData) : ''">
                <span>{{
                  record.row[tableItem.key].isInternationalization ? $t(getDisplayText(record.row[tableItem.key].text,
                    record.row[tableItem.key])) :
                    getDisplayText(record.row[tableItem.key].text, record.row[tableItem.key])
                }}</span>
              </p>
              <!-- 添加tooltip支持 -->
              <el-tooltip
                v-if="tableItem.tooltipText || (tableItem.tooltipTextFunc && tableItem.tooltipTextFunc(record.row[tableItem.key].itemData))"
                effect="dark"
                :content="$t(tableItem.tooltipTextFunc ? tableItem.tooltipTextFunc(record.row[tableItem.key].itemData) : tableItem.tooltipText)"
                placement="top" popper-class="text-popper">
                <i class="el-icon-warning-outline" style="margin-left: 5px; font-size: 14px;"></i>
              </el-tooltip>
              <p v-if="tableItem.type == 'checkbox'" class="ct-text-p">
                <el-checkbox v-model="record.row[tableItem.key].checkbox.checked"
                  @change="handleCheckedItemChange($event, record.row[tableItem.key])"></el-checkbox>
              </p>
              <!--图片显示-->
              <p v-if="tableItem.type == 'image'" class="ct-text-p"
                :style="record.row[tableItem.key].itemStyle ? record.row[tableItem.key].itemStyle(record.row[tableItem.key].itemData) : ''">
                <img
                  v-if="record.row[tableItem.key].imagePathFunc && record.row[tableItem.key].imagePathFunc(record.row[tableItem.key].itemData)"
                  class="ct-image-p"
                  :src="record.row[tableItem.key].imagePathFunc(record.row[tableItem.key].itemData)" />
                <span v-else>
                  {{
                    record.row[tableItem.key].isInternationalization ? $t(getDisplayText(record.row[tableItem.key].text,
                      record.row[tableItem.key])) :
                      getDisplayText(record.row[tableItem.key].text, record.row[tableItem.key])
                  }}
                </span>
              </p>
              <!--Tag显示-->
              <p v-if="tableItem.type == 'tag'" class="ct-text-p"
                :style="record.row[tableItem.key].itemStyle ? record.row[tableItem.key].itemStyle(record.row[tableItem.key].itemData) : ''">
                <el-tag
                  :type="record.row[tableItem.key].tagTypeFunc ? record.row[tableItem.key].tagTypeFunc(record.row[tableItem.key].itemData) : 'success'">
                  {{
                    record.row[tableItem.key].isInternationalization ? $t(getDisplayText(record.row[tableItem.key].text,
                      record.row[tableItem.key])) :
                      getDisplayText(record.row[tableItem.key].text, record.row[tableItem.key])
                  }}
                </el-tag>
              </p>

              <!--新增新的UI展示Status-->
              <p v-if="tableItem.type == 'status'" class="ct-text-p ct-status-p">
                <span class="status-dot"
                  :class="{ 'active': String(record.row[tableItem.key].itemData.status) === '0' || String(record.row[tableItem.key].itemData.status) === 'true', 'inactive': String(record.row[tableItem.key].itemData.status) === '1' || String(record.row[tableItem.key].itemData.status) === 'false' }"></span>
                {{
                  record.row[tableItem.key].isInternationalization ? $t(getDisplayText(record.row[tableItem.key].text,
                    record.row[tableItem.key])) :
                    getDisplayText(record.row[tableItem.key].text, record.row[tableItem.key])
                }}
              </p>

              <div v-if="tableItem.type == 'click'">
                <template v-for="(item, index) of record.row[tableItem.key].subTableDisplays">
                  <template v-if="item.type == 'text'">
                    <span :key="index" class="ct-text-p" v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)"
                      :style="item && item.itemStyles ? item.itemStyles : ''">
                      {{ item.isInternationalization ? $t(getDisplayText(item.text)) : getDisplayText(item.text) }}
                    </span>
                  </template>
                  <template v-if="item.type == 'text_button'">
                    <!-- 权限管理 -->
                    <template v-if="item.permissionCode">
                      <el-button type="text" :key="index" v-permission="item.permissionCode"
                        v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)" class="text_button"
                        :style="item && item.itemStyles ? item.itemStyles : ''"
                        @click="item && item.func ? item.func(item.value) : null">
                        {{ $t(getDisplayText(item.text)) }}
                      </el-button>
                    </template>
                    <template v-else>
                      <el-button type="text" :key="index"
                        v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)" class="text_button"
                        :style="item && item.itemStyles ? item.itemStyles : ''"
                        @click="item && item.func ? item.func(item.value) : null">
                        {{ $t(getDisplayText(item.text, item)) }}
                      </el-button>
                    </template>
                  </template>
                  <template v-if="item.type == 'link'">
                    <template v-if="item.permissionCode">
                      <router-link style="cursor: pointer" :key="index" v-permission="item.permissionCode"
                        v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)" class="ct-text-p"
                        :style="item && item.itemStyles ? item.itemStyles : ''"
                        :to="{ path: item.router, query: item.value ? item.value : {} }">
                        {{ item.isInternationalization ? $t(getDisplayText(item.text)) : getDisplayText(item.text) }}
                      </router-link>
                    </template>
                    <template v-else>
                      <router-link style="cursor: pointer" :key="index"
                        v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)" class="ct-text-p"
                        :style="item && item.itemStyles ? item.itemStyles : ''"
                        :to="{ path: item.router, query: item.value ? item.value : {} }">
                        {{ $t(getDisplayText(item.text)) }}
                      </router-link>
                    </template>
                  </template>
                  <template v-if="item.type == 'download'">
                    <template v-if="item.permissionCode">
                      <div v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)" :key="index">
                        <span style="cursor: pointer" v-permission="item.permissionCode" class="ct-text-p ct-file-p"
                          :style="item && item.itemStyles ? item.itemStyles : ''"
                          @click="item && item.func ? item.func(item.value) : null">
                          <span>{{ item.isInternationalization ? $t(getDisplayText(item.text)) :
                            getDisplayText(item.text) }}</span>
                          <i class="iconfont icon-Download"></i>
                        </span>
                        <span v-permission-else="item.permissionCode" :key="index">
                          {{ item.isInternationalization ? $t(getDisplayText(item.text)) : getDisplayText(item.text) }}
                        </span>
                      </div>
                    </template>
                    <template v-else>
                      <span :key="index" class="ct-text-p"
                        v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)"
                        :style="item && item.itemStyles ? item.itemStyles : ''">
                        {{ item.isInternationalization ? $t(getDisplayText(item.text)) : getDisplayText(item.text) }}
                      </span>
                    </template>
                  </template>
                  <template v-if="item.type == 'slot'">
                    <slot :name="tableItem.key" :row="record.row[tableItem.key].itemData"></slot>
                  </template>
                </template>
              </div>
              <!-- 操作 -->
              <div v-if="tableItem.type == 'operations'" style="display: flex; align-items: center;">
                <!-- 新增自定义操作按钮 -->
                <slot name="customOperations" :row="record.row"></slot>
                <template v-if="record.row.rhchOperationBtnCount >= 1">
                  <el-dropdown trigger="click" placement="bottom-start">
                    <span class="el-dropdown-link operations-wrapper">
                      <i class="el-icon-more"></i>
                    </span>
                    <template #dropdown>
                      <el-dropdown-menu class="operations-dropdown">
                        <p class="operation-title">{{ $t('message.tableCommon.operation') }}</p>
                        <el-dropdown-item v-for="(item, index) of record.row[tableItem.key].subTableDisplays"
                          :key="index">
                          <template v-if="item.type == 'text_button'">
                            <!-- 权限管理 -->
                            <template v-if="item.permissionCode">
                              <el-button type="text" class="operations-item" :key="index"
                                v-permission="item.permissionCode"
                                v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)"
                                :style="item && item.itemStyles ? item.itemStyles : ''"
                                @click="item && item.func ? item.func(item.value) : null">
                                {{ $t(getDisplayText(item.text)) }}
                              </el-button>
                            </template>
                            <template v-else>
                              <el-button type="text" class="operations-item" :key="index"
                                v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)"
                                :style="item && item.itemStyles ? item.itemStyles : ''"
                                @click="item && item.func ? item.func(item.value) : null">
                                {{ $t(getDisplayText(item.text, item)) }}
                              </el-button>
                            </template>
                          </template>
                          <template v-if="item.type == 'link'">
                            <template v-if="item.permissionCode">
                              <router-link style="cursor: pointer" :key="index" v-permission="item.permissionCode"
                                v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)"
                                class="ct-text-p operations-item"
                                :style="item && item.itemStyles ? item.itemStyles : ''"
                                :to="{ path: item.router, query: item.value ? item.value : {} }">
                                {{
                                  item.isInternationalization ? $t(getDisplayText(item.text)) : getDisplayText(item.text)
                                }}
                              </router-link>
                            </template>
                            <template v-else>
                              <router-link style="cursor: pointer" :key="index"
                                v-if="!item.isDisplayFunc || item.isDisplayFunc(item.itemData)"
                                class="ct-text-p operations-item"
                                :style="item && item.itemStyles ? item.itemStyles : ''"
                                :to="{ path: item.router, query: item.value ? item.value : {} }">
                                {{ $t(getDisplayText(item.text)) }}
                              </router-link>
                            </template>
                          </template>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </template>
              </div>
              <!-- 开放插槽，便于自定义使用 -->
              <template v-if="tableItem.type == 'slot'">
                <slot :name="tableItem.key" :row="record.row[tableItem.key].itemData"></slot>
              </template>
            </div>
          </template>
        </el-table-column>
      </template>
      <template slot="empty">
        <div class="table-empty">
          <slot v-if="!tableLoadingKey" name="rhcn-empty">
            <empty-component :empty-subtitle="$t('message.tableCommon.searcnEmpty')"></empty-component>
          </slot>
        </div>
      </template>
    </el-table>
    <div class="table-pagination">
      <el-pagination v-if="paginationInfo.totalSize != 0 && isPaginationDisplay" background :page-sizes="[10, 20, 50]"
        :current-page="paginationInfo.currentPage" :page-size="paginationInfo.pageSize"
        :total="paginationInfo.totalSize" layout="total, sizes, prev, pager,jumper,next"
        :prev-text="$t('message.tableTitleCommon.previous')" :next-text="$t('message.tableTitleCommon.next')"
        @current-change="onCurrentPageChange" @size-change="onPageSizeChange" />
    </div>
  </div>
</template>
<script>
import TitleSettings from '@/components/table/components/title-settings.vue';
import EmptyComponent from '@/components/table/empty-component.vue';
import { SEARCH_GET_NAME, SEARCH_GET_VALUE, SEARCH_TITLE_SEARCH } from '@/store/modules/search';
import { initExhibitionTable } from '@/utils/tools/constant.js';
import { formatDate } from '@/utils/tools/time';
import { comparisonObject, isNullForDisplay, isNullForTransferValue, shallowClones } from '@/utils/tools/utils.js';

export default {
  name: 'CustomTable',
  components: {
    EmptyComponent,
    TitleSettings,
  },
  props: {
    /**
     * 模版
     */
    tableSet: Array,
    /**
     * 是否需要用到转圈
     */
    isLoading: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否显示分页
     */
    isPaginationDisplay: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否显示分页
     */
    isWatchPathChange: {
      type: Boolean,
      default: true,
    },
    /**
     * 是否显示全选功能
     */
    showSelection: {
      type: Boolean,
      default: false,
    },
    /**
     * 是否显示行选择功能
     */
    showRowSelection: {
      type: Boolean,
      default: false,
    },
    /**
     * 分页查询的方法
     */
    serviceFunction: {
      type: Function,
      default: null,
    },
    /**
     * 路由的名称
     */
    routerName: {
      type: String,
      default: '',
    },
    /**
     * 第一次请求的时候所带参数
     */
    firstParameters: {
      type: Object,
      default: () => null,
    },
    /**
     * 每次请求的时候要额外添加的参数
     */
    additionalParameters: {
      type: Object,
      default: () => null,
    },
    /**
     * 第一次进入页面是否自动访问网络
     */
    isFirstAutomaticVisit: {
      type: Boolean,
      default: true,
    },
    /**
     * 存储data(用于实时显示)
     */
    storedData: {
      type: Object,
      default: null,
    },
    /**
     * 显示商户号列表
     */
    showMerchantNo: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['serviceFunStartCallback', 'serviceFunEndCallback', 'selection-change'],
  data() {
    return {
      tableId: `table-${Math.floor(Math.random() * 100000000)}`,
      maxHeight: 865,
      tableData: [],
      cacheData: null,
      tableLoadingKey: false,
      /**
       *用于静态数据保存(主要用于分页)
       */
      paginationInfo: {
        currentPage: 1,
        pageSize: 10,
        totalSize: 0,
      },
      titleSettingsKey: false,
      viewRefreshKey: true,
      titleIconDisplay: false,
      // 保存初始化的Title设置
      backupsTableSet: null,
      innerTableSet: [],
    };
  },
  methods: {
    handleSelectionChange(selection) {
      this.$emit('selection-change', selection);
    },
    setTableLoadingShow() {
      this.tableLoadingKey = true;
    },
    setTableLoadingHide() {
      this.tableLoadingKey = false;
    },
    getPageParams() {
      return {
        current: `${this.paginationInfo.currentPage}`,
        size: `${this.paginationInfo.pageSize}`,
      };
    },
    getParams() {
      let params = {};
      if (comparisonObject({}, this.$route.query) && this.firstParameters) {
        params = this.firstParameters;
      }
      params = Object.assign({}, params, this.$route.query, this.additionalParameters, this.getPageParams());
      return params;
    },
    getTableItem(tableSetItem, itemData) {
      const tableTd = shallowClones(tableSetItem);
      if (tableTd.type === 'checkbox') {
        tableTd.checkbox = tableTd.checkbox || {};
        tableTd.checkbox.checked = false;
      }
      if (tableTd.type === 'operations' && tableTd.subTableDisplays) {
        tableTd.subTableDisplays.forEach(subItem => {
          if (subItem.type === 'text_button') {
            subItem.text = typeof subItem.text === 'function' ? subItem.text(itemData) : subItem.text;
          }
        });
      } else {
        tableTd.text = tableSetItem.textFunc
          ? tableSetItem.textFunc(itemData, tableTd) : itemData[tableSetItem.key];
      }
      tableTd.authId = tableTd.authId ? tableTd.authId : '';
      if (tableTd.valueKey) {
        if (typeof tableSetItem.valueKey === 'string') {
          tableTd.value = {
            [tableSetItem.paramsKey ? tableSetItem.paramsKey
              : tableSetItem.valueKey]: itemData[tableSetItem.valueKey] ? itemData[tableSetItem.valueKey] : '',
          };
        } else {
          tableTd.value = {};
          for (let i = 0; i < tableSetItem.valueKey.length; i++) {
            tableTd.value[tableSetItem.paramsKey && tableSetItem.paramsKey[i]
              ? tableSetItem.paramsKey[i] : tableSetItem.valueKey[i]] = (itemData[tableSetItem.valueKey[i]] ? itemData[tableSetItem.valueKey[i]] : '');
          }
        }
      } else if (tableSetItem.func) {
        tableTd.value = itemData;
      } else {
        tableTd.value = '';
      }
      tableTd.itemData = itemData;
      return tableTd;
    },
    analysisData(data) {
      const arr = [];
      if (data) {
        data.forEach((item, index) => {
          const dataItem = {};
          dataItem.key = index;
          // 操作按钮个数
          let operationBtnCount = 0;
          if (this.innerTableSet) {
            this.innerTableSet.forEach((tableSetItem) => {
              const keyName = tableSetItem.key ? tableSetItem.key : 'nullData';
              if (tableSetItem.subTableDisplays) {
                const tableTd = shallowClones(tableSetItem);
                const subTds = [];
                tableSetItem.subTableDisplays.forEach((subTableDisplayItem, i) => {
                  const itemObj = this.getTableItem(subTableDisplayItem, item);
                  itemObj.key = i;
                  subTds.push(itemObj);
                  if (tableSetItem.type === 'operations') {
                    let isDisplayOperationBtn = true;
                    let isPermissionOperationBtn = true;
                    if (subTableDisplayItem.isDisplayFunc) {
                      isDisplayOperationBtn = subTableDisplayItem.isDisplayFunc(item);
                    }
                    if (subTableDisplayItem.permissionCode) {
                      isPermissionOperationBtn = this.$store.getters.permission.permissionCodes.includes(subTableDisplayItem.permissionCode);
                    }
                    if (isDisplayOperationBtn && isPermissionOperationBtn) {
                      operationBtnCount += 1;
                    }
                  }
                });
                tableTd.subTableDisplays = subTds;
                dataItem[keyName] = tableTd;
              } else {
                dataItem[keyName] = this.getTableItem(tableSetItem, item);
              }
            });
          }
          dataItem.rhchOperationBtnCount = operationBtnCount;
          arr.push(dataItem);
        });
      }
      return arr;
    },
    /**
     *  设置数据展示
     * @param data
     */
    setTable(data) {
      if (data) {
        this.viewRefreshKey = false;
        if (this.$refs && this.$refs.titleSettings && this.$refs.titleSettings.length > 0) {
          if (!this.$refs.titleSettings[0].isTitleSorting && (this.$refs.titleSettings[1] && this.$refs.titleSettings[1].isTitleSorting)) {
            this.getNewTableSet(this.backupsTableSet);
          } else if (this.$refs.titleSettings[0].isTitleSorting || (this.$refs.titleSettings[1] && this.$refs.titleSettings[1].isTitleSorting)) {
            this.sortArrayOrder();
          }
        } else {

        }
        data.content = this.analysisData(data.content);
        if (data.current) {
          this.paginationInfo.currentPage = +data.current;
        }
        if (data.size) {
          this.paginationInfo.pageSize = +data.size;
        }
        if (data.totalElements) {
          this.paginationInfo.totalSize = +data.totalElements;
        } else {
          this.paginationInfo.totalSize = 0;
        }
      }
      this.tableData = data.content;
      this.$nextTick(() => {
        this.viewRefreshKey = true;
      });
    },
    httpGetList(params) {
      if (this.serviceFunction) {
        this.$emit('serviceFunStartCallback');
        this.setTableLoadingShow();
        this.serviceFunction(params, this.$parent).then((data) => {
          this.setTable(shallowClones(data));
          /**
           * 显示搜索参数对应的筛选图标
           */
          this.setFilterIconDisplay(params);
          this.setTableLoadingHide();
          this.$emit('serviceFunEndCallback', data);
        }).catch((error) => {
          if (error !== 'customerErrorHandler') {
            this.setTable({});
          }
          this.setTableLoadingHide();
          this.$emit('serviceFunEndCallback', {});
        });
      }
    },
    setHttpUrl(params) {
      this.$router.push({ path: this.routerName, query: params });
    },
    httpData(params) {
      if (comparisonObject({}, params) && this.firstParameters) {
        this.httpGetList(this.firstParameters);
      } else if (comparisonObject({}, params) && this.additionalParameters) {
        this.httpGetList(this.additionalParameters);
      } else if (comparisonObject(params, this.$route.query)) {
        this.httpGetList(params);
      } else {
        this.setHttpUrl(params);
      }
    },
    saveCacheData(list) {
      const obj = initExhibitionTable(list, true, 10, list.length);
      this.cacheData = shallowClones(obj);
    },
    /**
     * 静态数据页面变更
     */
    setStaticPaging(currPage, pageSize, checkName) {
      if (this.cacheData && this.cacheData.content) {
        const data = shallowClones(this.cacheData);
        const list = data.content.filter((item, i) => i > ((pageSize * currPage) - this.paginationInfo.pageSize - 1) && i < (currPage * pageSize));
        data.content = list;
        data.current = currPage;
        data.size = pageSize;
        this.setTable(data);
      } else {
        this.setTable({});
      }
      const item = this.innerTableSet.find((tableItem) => tableItem.key === (checkName || 'checkbox'));
      if (item) {
        item.titleBar.checkbox.checked = false;
        // item.titleBar.checkbox.indeterminate = false;
      }
    },
    onCurrentPageChange(index) {
      if (index >= 1) {
        this.paginationInfo.currentPage = index;
        if (this.cacheData) {
          this.setStaticPaging(index, this.paginationInfo.pageSize);
        } else {
          this.httpData(this.getParams());
        }
      }
    },
    onPageSizeChange(size) {
      this.paginationInfo.currentPage = 1;
      this.paginationInfo.pageSize = size;
      if (this.cacheData) {
        this.setStaticPaging(this.paginationInfo.currentPage, size);
      } else {
        this.httpData(this.getParams());
      }
    },
    /**
     * 刷新表格
     */
    refreshTable() {
      this.httpData(this.$route.query);
    },
    /**
     * 第一次手动访问Http数据
     */
    firstVisitHttp() {
      this.httpGetList(shallowClones(this.firstParameters, this.$route.query));
    },
    // ---------------  CheckBox - Start-----------------
    /**
     * 表格中单个条目点击时触发
     * @param appTable
     * @param tableItem
     * @param key 一个Table里面有2种
     */
    setSelectItemStatus(tableItem) {
      const iItem = this.innerTableSet.find((data) => data.key === tableItem.key);
      const content = this.tableData;
      if (content.every((item) => item[tableItem.key].checkbox.checked)) {
        iItem.titleBar.checkbox.checked = true;
        // iItem.titleBar.checkbox.indeterminate = false;
      } else if (content.every((item) => !item[tableItem.key].checkbox.checked)) {
        iItem.titleBar.checkbox.checked = false;
        // iItem.titleBar.checkbox.indeterminate = false;
      } else {
        iItem.titleBar.checkbox.checked = false;
        // iItem.titleBar.checkbox.indeterminate = true;
      }
    },
    /**
     * 表格中全选点击时触发
     * @param appTable
     * @param event
     * @param key
     */
    setSelectAllStatus(event, titleItem) {
      const content = this.tableData;
      // tableItem.titleBar.checkbox.indeterminate = false;
      content.forEach((item) => {
        item[titleItem.key].checkbox.checked = event;
      });
    },
    handleCheckAllChange(value, item) {
      this.setSelectAllStatus(value, item);
    },
    handleCheckedItemChange(value, item) {
      this.setSelectItemStatus(item);
    },
    /**
     * 获得选中的条目列表
     * @param valueKey 直接通过key值得到需要的array
     * @param itemKey 多个多选框时候的查询多选框条目
     * @return {any[]}
     */
    getCheckedAllList(valueKey, itemKey) {
      const list = this.tableData;
      const arr = [];
      list.forEach((item) => {
        const subItem = item[(itemKey || 'checkbox')];
        if (subItem.checkbox.checked) {
          if (subItem.isDisplayFunc) {
            if (subItem.isDisplayFunc(subItem.itemData)) {
              if (valueKey) {
                arr.push(subItem.itemData ? subItem.itemData[valueKey] : '');
              }
            }
          } else if (valueKey) {
            arr.push(subItem.itemData ? subItem.itemData[valueKey] : '');
          }
        }
      });
      return arr;
    },
    // ---------------  CheckBox - End-----------------
    getDisplayText(data) {
      return isNullForDisplay(data, '');
    },
    onSearchListens(val, a) {
      if (this.$store.getters[SEARCH_GET_NAME] === this.routerName) {
        this.httpData(shallowClones(JSON.parse(this.$store.getters[SEARCH_GET_VALUE]), this.additionalParameters));
      }
    },
    onPathChangeListens(val, a) {
      if (this.routerName && this.$route.path === this.routerName && this.isWatchPathChange) {
        this.httpData(this.$route.query);
      }
    },
    setFilterIconDisplay(params) {
      this.titleIconDisplay = !this.titleIconDisplay;
      this.innerTableSet.forEach(item => {
        if (item.titleBar && item.titleBar.filterKey && params[item.titleBar.filterKey] !== undefined) {
          item.titleBar.isFilterChecked = true;
        } else {
          item.titleBar.isFilterChecked = false;
        }
      });
    },
    onFilterIconClick(item) {
      this.$store.commit(SEARCH_TITLE_SEARCH, {
        name: this.routerName,
        value: [{ titleSearchKey: item.filterKey, queryDisplayValue: '1' }],
        time: formatDate(new Date()),
      });
    },
    // ---------------  TitleSettings - Start-----------------
    // onTitleSettingsClick() {
    //   this.titleSettingsKey = !this.titleSettingsKey;
    // },
    // onTitleSettingsClose() {
    //   this.titleSettingsKey = false;
    // },
    /**
     * table显示排序
     */
    sortArrayOrder() {
      const array = [...this.innerTableSet];
      array.sort((a, b) => {
        if (a.isNotSort || b.isNotSort) {
          return 0;
        }
        return isNullForTransferValue(String(a.index)) && isNullForTransferValue(String(b.index)) ? a.index - b.index : 1;
      });
      this.getNewTableSet(array);
    },
    getNewTableSet(array) {
      array.forEach((item, index) => {
        this.innerTableSet[index] = shallowClones(item);
      });
    },
    getTableData() {
      return this.tableData;
    },
  },
  watch: {
    '$store.state.search.routerTime': 'onSearchListens',
    $route: 'onPathChangeListens',
  },
  created() {
    this.innerTableSet = shallowClones(this.tableSet);
    try {
      const userLogin = this.$store.getters.app.userLogin;
      // 是否是集团商户
      const isGroupMerchant = `${userLogin.merchantType}` === '3';
      if (isGroupMerchant && this.showMerchantNo) {
        this.innerTableSet.splice(1, 0, { // 结算币种
          titleBar: { type: 'text', title: 'message.account.merchantNo' },
          key: 'merchantNo',
          type: 'text',
        });
      }
    } catch (err) {
      //
    }
    this.backupsTableSet = shallowClones(this.innerTableSet);
  },
  mounted() {
    if (this.isFirstAutomaticVisit) {
      if (this.firstParameters || this.additionalParameters) {
        this.httpGetList(shallowClones(shallowClones(this.firstParameters, this.additionalParameters), this.$route.query));
      } else {
        this.httpData(shallowClones(this.$route.query, this.additionalParameters));
      }
    }
    if (this.storedData) {
      this.setTable((this.storedData));
    }

    try {
      const box = document.getElementById(this.tableId).getBoundingClientRect();
      this.maxHeight = window.innerHeight - box.top - 100;
      if (this.maxHeight < 500) {
        this.maxHeight = 500;
      }
    } catch (err) {
      //
    }
  },
};
</script>
<style lang="scss">
@import '@/styles/variables.scss';

#customTable {
  width: 100%;

  td {
    color: $color-text-primary;
  }

  .el-table__fixed,
  .el-table__fixed-right {
    box-shadow: none;
  }

  .ct-text-p {
    display: inline-block;
    margin: 0px;
    cursor: default;
    font-family: Avenir-Book, Avenir;
    font-weight: normal;
    word-break: auto-phrase;
  }

  .text_button {
    padding: 0;
    font-weight: normal;
    font-size: 14px;
    user-select: text;
  }

  .ct-file-p {
    height: 30px;
    background: #F1F5F7;
    border-radius: 4px;
    padding: 0 8px;
    font-size: 14px;
    font-weight: 800;
    line-height: 30px;
    cursor: pointer;
    color: $color-text-primary;

    .icon-Download {
      font-size: 14px;
      color: $color-text-default-button;
      margin-left: 5px;
    }
  }

  .ct-image-p {
    width: auto;
    height: 25px;
    border-radius: 4px;
    vertical-align: middle;
  }

  .el-table__header {

    .operations-column {
      .ct-text-p {
        justify-content: flex-end;

        .title-settings {
          margin-right: 18px;
        }
      }
    }

    .ct-text-p {
      color: $color-text-primary;
      font-family: Avenir-Heavy, Avenir;
      font-weight: 800;
      width: 100%;
      display: flex;
      // justify-content: space-between;
      align-items: center;

      i {
        font-size: 19px;
        cursor: pointer;
      }

      .icon-shaixuan {
        color: rgba($color-text-default-button, 0.4);
        font-weight: 100;
        cursor: pointer;
        margin-left: 5px;
      }
    }
  }

  .el-table__header {
    th {
      padding: 13px 0px;
    }

    th.el-table__cell {
      user-select: initial;
    }

    tr .el-table__cell {
      background: #FFFFFF;
      padding-left: 12px;
      padding-right: 12px;
    }
  }

  // align 设置时 表格内容处理
  .el-table td.el-table__cell {
    &.is-left>div {
      justify-content: flex-start !important;
    }

    &.is-right>div {
      justify-content: flex-end !important;
    }
  }

  // align 设置时 表头内容处理
  .el-table th.el-table__cell {
    &.is-left>div>.ct-text-p {
      justify-content: flex-start !important;
    }

    &.is-right>div>.ct-text-p {
      justify-content: flex-end !important;
    }
  }

  .el-table th.el-table__cell>.cell,
  .el-table td.el-table__cell div {
    padding-left: 0;
    padding-right: 0;

  }

  .el-table td.el-table__cell .cell {
    display: flex;
    align-items: center;
    min-height: 28px;
  }

  .el-table td.el-table__cell.operations-column.el-table__cell .cell {
    justify-content: flex-end;
    padding-right: 12px;
  }

  .el-table__row {
    .el-table__cell {
      padding-left: 12px;
      padding-right: 12px;
      padding-top: 6px;
      padding-bottom: 6px;
    }
  }

  .table-pagination {
    padding: 15px 25px;
    padding-right: 2px;
    text-align: right;
    position: relative;

    .number,
    .btn-prev,
    .btn-next,
    .btn-quicknext,
    .btn-quickprev {
      display: inline-block;
      width: 36px;
      height: 30px;
      border-radius: 4px;
      text-align: center;
      margin: 0 5px;
    }

    .btn-prev,
    .btn-next {
      width: 80px;
    }

    .el-pagination__jump .el-input,
    .el-pagination__jump .el-input__inner {
      height: 100%;
    }

    .el-pagination__jump,
    .el-pagination__sizes,
    .el-pagination__sizes .el-input__inner,
    .el-pagination__total {
      height: 30px;
      display: inline-flex;
      align-items: center;
      line-height: 30px;
      margin: 0px;
      color: $color-text-primary;
    }

    .el-pagination__total {
      position: absolute;
      left: 12px;
    }
  }

  .el-table {
    .el-table__empty-block {
      width: 100% !important;
    }
  }

  .el-table__empty-text {
    width: 100%;
  }

  .table-empty {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 416px;
  }

  .operations-wrapper {
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: white;
    }

    .el-icon-more {
      color: #00203F;
      font-size: 23px;
      cursor: pointer;
    }

    .el-button {
      margin-left: 0px;
      padding-left: 0px;
      min-width: auto;
    }
  }

  .el-select__caret {
    line-height: 30px;
  }
}

.operations-dropdown {
  &.el-dropdown-menu {
    // background-color: #F2F5F7;
    // box-shadow: -2px 4px 10px 0px rgba(0, 0, 0, 0.08);
    // border-color: #F2F5F7;
    width: 246px;
    background: #FFFFFF;
    box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.05);
    border-radius: 2px;
    padding: 10px;
    padding-top: 4px;

    .operation-title {
      margin-left: 13px;
      height: 30px;
      line-height: 30px;
    }

    .el-dropdown-menu__item {
      color: $color-text-primary;
      background-color: #F4F6F8;

      .el-button {
        padding: 0;
        width: 100%;
        height: 34px;
        min-width: auto;
        font-size: 14px;
        justify-content: flex-start;
      }

      .el-button--text {
        color: inherit;
      }
    }

    .el-dropdown-menu__item:not(.is-disabled):hover,
    .el-dropdown-menu__item:focus {
      color: white;
      background-color: $color-text-primary;
    }

    &[x-placement^=bottom] {
      .popper__arrow {
        border-bottom-color: #F2F5F7 !important;

        &::after {
          border-bottom-color: #F2F5F7 !important;
        }
      }
    }

    &[x-placement^=top] {
      .popper__arrow {
        border-top-color: #F2F5F7 !important;

        &::after {
          border-top-color: #F2F5F7 !important;
        }
      }
    }
  }
}

.ct-status-p {
  display: flex !important;
  align-items: center;
  // font-family: "Open Sans", "Open Sans";
  // font-weight: 400;
  // font-size: 16px;
  // color: #1A202C;
  // line-height: 22px;
  // text-align: left;
  // font-style: normal;
  // text-transform: none;

  .status-dot {
    width: 9px;
    height: 9px;
    border-radius: 50%;
    margin-right: 12px;

    &.active {
      background-color: #00B42A;
    }

    &.inactive {
      background-color: #F53F3F;
    }
  }
}
</style>
